import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { setRef } from './utils';

export interface IProps {
  /** HTML элемент где будет добавляться портал, по умолчанию "document.body"  */
  container?: HTMLElement | null;
}

/**
 * Компонент Портала в DOM
 */
export const Portal = React.forwardRef<HTMLElement, React.PropsWithChildren<IProps>>(({ container, children }, ref) => {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setMountNode(container || document.body);
    }
  }, [container]);

  useEffect(() => {
    if (mountNode) {
      setRef(ref, mountNode);
      return () => {
        setRef(ref, null);
      };
    }
  }, [ref, mountNode]);

  return mountNode && ReactDOM.createPortal(children, mountNode);
});

Portal.displayName = 'Portal';
